module.exports = ".btn.disabled, .btn[disabled], fieldset[disabled] .btn {\n  pointer-events: auto; }\n"